import { ApiClient } from "#/shared/api/client";

class EventApi extends ApiClient {
  constructor() {
    super({ api: "sp_checkout" });
  }
}

export function createEventApi() {
  const api = new EventApi();

  return {
    fetchEvent: async (url) => api.get(url),
  };
}
